import { AppService, AppTypes } from 'st-app/Services/AppService';

import { AppServices } from '@singularsystems/neo-core';
import { IApprovalsCommandApiClient } from './ApiClients/Approvals/ApprovalsCommandApiClient';
import { IParticipantAcceptanceCommandApiClient } from './ApiClients/ParticipantOffers/ParticipantAcceptanceCommandApiClient';
import { IParticipantOffersQueryApiClient } from './ApiClients/ParticipantOffers/ParticipantOffersQueryApiClient';
import { Types as CommonTypes } from 'st-common/Awards/CommonAwardsTypes';
import { IAwardDocumentsCommandApiClient } from 'st-common/Awards/ApiClients/AwardDocuments/AwardDocumentsCommandApiClient';
import { AwardsSharedTypes } from './AwardsSharedTypes';

// Merge the shared type symbols with this module's type symbols
const Types = {
    ...AppTypes,
    Awards: {
        ApiClients: {
            ...CommonTypes.ApiClients,
            ...AwardsSharedTypes.ApiClients,
            ApprovalsCommandApiClient: new AppServices.ServiceIdentifier<IApprovalsCommandApiClient>("Awards.ApiClients.ApprovalsCommandApiClient"),
            ParticipantOffersQueryApiClient: new AppServices.ServiceIdentifier<IParticipantOffersQueryApiClient>("Awards.ApiClients.ParticipantOffersQueryApiClient"),
            ParticipantAcceptanceCommandApiClient: new AppServices.ServiceIdentifier<IParticipantAcceptanceCommandApiClient>("Awards.ApiClients.ParticipantAcceptanceCommandApiClient"),
            AwardDocumentCommandApiClient: new AppServices.ServiceIdentifier<IAwardDocumentsCommandApiClient>("Awards.ApiClients.AwardDocumentCommandApiClient")
        },
        Services : {
            ...AwardsSharedTypes.Services,
            ...CommonTypes.Services
        }
    }
};

export { AppService, Types }
